import { signInWithGoogle } from '../config/auth';
import gifts from '../assets/signup-image.jpg';
import './SignUp.css';
import { toast } from 'sonner';
import { Navbar } from '../components/Navbar';

export default function SignUp() {

    const handleSignIn = async () => {
        try {
            await signInWithGoogle();
            // onAuthStateChanged fires → SignUpOrDashboard redirects to /events
        } catch (error: unknown) {
            const code = (error as { code?: string })?.code;
            if (code === 'auth/popup-closed-by-user' || code === 'auth/cancelled-popup-request') return;
            toast.error('Sign-in failed. Please try again.');
        }
    };

    return (
        <>
            <Navbar />
            <div className="signup-page">
            <div className="signup-inner">
                <div className="signup-content">
                    <div className="signup-text">
                        <h1 className="signup-title">Plan your gifts and track budget limits with GiftGiver</h1>
                        <h2 className="signup-subtitle">Put the people in your life first and never buy a last-minute gift again!</h2>
                    </div>
                    <button className="signup-button" onClick={handleSignIn}>
                        <img src='/google.svg' alt="Google Icon" className="google-icon" />
                        Sign up with your Google account
                    </button>
                </div>
                <div className="signup-image-wrap">
                    <img src={gifts} alt="Gift giving image" className="signup-image" />
                </div>
            </div>
        </div>
        </>
    );
}
